/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {coerceBooleanProperty, coerceNumberProperty} from '@angular/cdk/coercion';
import {Component, Input, ViewEncapsulation} from '@angular/core';
import {MATERIAL_COMPATIBILITY_MODE} from '@angular/material/core';
import {MdStepLabel} from './step-label';
export class MdStepHeader {
/**
 * Icon for the given step.
 */
icon: string;
/**
 * Label of the given step.
 */
label: MdStepLabel | string;
/**
 * Index of the given step.
 * @return {?}
 */
get index() { return this._index; }
/**
 * @param {?} value
 * @return {?}
 */
set index(value: any) {
    this._index = coerceNumberProperty(value);
  }
private _index: number;
/**
 * Whether the given step is selected.
 * @return {?}
 */
get selected() { return this._selected; }
/**
 * @param {?} value
 * @return {?}
 */
set selected(value: any) {
    this._selected = coerceBooleanProperty(value);
  }
private _selected: boolean;
/**
 * Whether the given step label is active.
 * @return {?}
 */
get active() { return this._active; }
/**
 * @param {?} value
 * @return {?}
 */
set active(value: any) {
    this._active = coerceBooleanProperty(value);
  }
private _active: boolean;
/**
 * Whether the given step is optional.
 * @return {?}
 */
get optional() { return this._optional; }
/**
 * @param {?} value
 * @return {?}
 */
set optional(value: any) {
    this._optional = coerceBooleanProperty(value);
  }
private _optional: boolean;
/**
 * Returns string label of given step if it is a text label.
 * @return {?}
 */
_stringLabel(): string | null {
    return this.label instanceof MdStepLabel ? null : this.label;
  }
/**
 * Returns MdStepLabel if the label of given step is a template label.
 * @return {?}
 */
_templateLabel(): MdStepLabel | null {
    return this.label instanceof MdStepLabel ? this.label : null;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-step-header, mat-step-header',
  templateUrl: 'step-header.html',
  styleUrls: ['step-header.css'],
  host: {
    'class': 'mat-step-header',
    'role': 'tab',
  },
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  viewProviders: [{provide: MATERIAL_COMPATIBILITY_MODE, useValue: true}],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'icon': [{ type: Input },],
'label': [{ type: Input },],
'index': [{ type: Input },],
'selected': [{ type: Input },],
'active': [{ type: Input },],
'optional': [{ type: Input },],
};
}

function MdStepHeader_tsickle_Closure_declarations() {
/** @type {?} */
MdStepHeader.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdStepHeader.ctorParameters;
/** @type {?} */
MdStepHeader.propDecorators;
/**
 * Icon for the given step.
 * @type {?}
 */
MdStepHeader.prototype.icon;
/**
 * Label of the given step.
 * @type {?}
 */
MdStepHeader.prototype.label;
/** @type {?} */
MdStepHeader.prototype._index;
/** @type {?} */
MdStepHeader.prototype._selected;
/** @type {?} */
MdStepHeader.prototype._active;
/** @type {?} */
MdStepHeader.prototype._optional;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
